import React, { FC, useContext } from 'react';

import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useHierarchicalMenu } from 'react-instantsearch-hooks-web';
import { useParams } from 'react-router-dom';

import { DEFAULT_DISCOVER_URL } from '../../../../const';
import { DiscoverContext } from '../../../../context/DiscoverContext';
import { CategoryNavigation } from '../CategoryNavigation';
import useStyles from './styles';

interface CategoryNavigationBlockProps {
  attributes: string[];
}

export const CategoryNavigationBlock: FC<CategoryNavigationBlockProps> = ({ attributes }) => {
  const { t } = useTranslation();
  const classes = useStyles();
  const params = useParams();
  const { categoryTitle } = useContext(DiscoverContext);

  const { category, subcategory } = params;

  useHierarchicalMenu({ attributes });

  return (
    <Box className={classes.wrapper}>
      {subcategory && (
        <CategoryNavigation
          link={`${DEFAULT_DISCOVER_URL}/${category}`}
          title={t('page.discover.backTo', { category: categoryTitle })}
        />
      )}
      <CategoryNavigation
        link={`${DEFAULT_DISCOVER_URL}/search`}
        title={t('page.discover.backToLanding')}
      />
    </Box>
  );
};

export default CategoryNavigationBlock;
